import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconStarWand: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconStarWand"><Path d="M17.8581 2.52002L11.9652 5.51801L6.07222 2.52002L7.10233 9.05123L2.43018 13.7296L8.95977 14.7681L11.9652 20.6575L14.9706 14.7681L21.5002 13.7296L16.828 9.05123L17.8581 2.52002Z" stroke="currentColor" strokeLinecap="square"/><Path d="M8.60849 15.1677L3.85938 21.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconStarWand;
